import { faChevronsRight } from '@fortawesome/pro-solid-svg-icons/faChevronsRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	ButtonSubmit,
	ColourStateSolid,
	FlexGap,
	StackVertical,
	ToggleSwitch,
	ToggleType,
} from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useState } from 'react';
import { RulesetAction } from './Action/RulesetAction';
import { RulesetFilters } from './Filter/RulesetFilters';
import { RulesetName } from './RulesetName';
import { RulesetScanType } from './Type/RulesetScanType';

function CreateRuleset() {
	const { getValues, setValue } = useFormContext();
	const [activeFilters, setActiveFilters] = useState<Array<number>>([]);

	const itemCount = Math.floor(Math.random() * 10);

	return (
		<div className='card thing thing-vertical'>
			<div className='thing-wrapper'>
				<div className='thing-container thing-container-start'>
					<h6 className='thing-title sub-heading pageantry-sub-heading text-left '>Ruleset Name</h6>
					<RulesetName name='name' />
				</div>

				<div className='thing-separator'>
					<div className='thing-separator-icon'>
						<FontAwesomeIcon icon={faChevronsRight} />
					</div>
				</div>

				<div className='thing-container'>
					<h6 className='thing-title sub-heading pageantry-sub-heading text-left '>If Criteria Matches</h6>
					<RulesetScanType name='scanType' />
					<RulesetFilters
						name='filters'
						activeFilters={activeFilters}
						filterChangedCallback={(val: Array<number>) => setActiveFilters(val)}
					/>
				</div>

				<div className='thing-separator'>
					<div className='thing-separator-icon'>
						<FontAwesomeIcon icon={faChevronsRight} />
					</div>
				</div>

				<div className='thing-container thing-container-end'>
					<h6 className='thing-title sub-heading pageantry-sub-heading text-left '>Then Do This</h6>
					<RulesetAction name='action' />
				</div>

				<div className='thing-separator'>
					<div className='thing-separator-icon'>
						<FontAwesomeIcon icon={faChevronsRight} />
					</div>
				</div>

				<div className='thing-container thing-container-end'>
					{itemCount > 0 && (
						<h6 className='thing-title sub-heading pageantry-sub-heading text-left '>Finalise</h6>
					)}

					<StackVertical gap={FlexGap.Medium}>
						{itemCount > 0 && (
							<ToggleSwitch
								name='ApplyExisting'
								label={`Apply to ${itemCount} matching ${itemCount === 1 ? 'item' : 'items'}?`}
								type={ToggleType.Checkbox}
								defaultChecked={getValues(`applyToExisting`)}
								onChange={(e) => setValue(`applyToExisting`, e.currentTarget.checked)}
							/>
						)}

						<ButtonSubmit
							fullWidth
							title='Save Ruleset'
							colour={ColourStateSolid.Primary}
							extraClass='ml-a'
						/>
					</StackVertical>
				</div>
			</div>
		</div>
	);
}

export { CreateRuleset };
